module.exports = __webpack_public_path__ + "img/mi2.f192b169.png";